import { Autocomplete, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

import lookupManager from '../../../utils/lookupManager';

import useCountryRequest from '../../../requests/CountryRequest';

const CountrySelect = ({
  name = 'country_id',
  size = 'small',
  value = '',
  defaultIso2 = 'US',
  required = false,
  fullWidth = false,
  disabled = false,
  placeholder = '',
  error = false,
  helperText = '',
  selectDefault = false,
  onChange,
  returnIso2 = false, // if true, onChange will return the iso2 code instead of the country_id
  errorHandler,
  label,
}) => {
  const { getCountries } = useCountryRequest();

  const [countries, setCountries] = useState([]);
  const [changed, setChanged] = useState(false);

  useEffect(() => {
    const loadCountries = async () => {
      const countries = await lookupManager.lookup('countries', async () => {
        return await getCountries(errorHandler, true);
      });
      const mapped = countries.map((c) => {
        return {
          ...c,
          id: returnIso2 ? c.iso_code_2 : c.country_id,
          label: c.name,
        };
      });
      console.log(mapped);
      setCountries(mapped);
    };
    loadCountries();
  }, []);

  const selected = useMemo(() => {
    if (typeof value === 'object') {
      if (!value.id) {
        return {};
      }

      if (returnIso2) {
        return countries.find((c) => c.id === value.id) || {};
      }

      return countries.find((c) => c.id === parseInt(value.id)) || {};
    }

    if (!value) {
      return {};
    }
    if (returnIso2) {
      return countries.find((c) => c.id === value) || {};
    }
    return countries.find((c) => c.id === parseInt(value)) || {};
  }, [countries, value]);

  const defaultCountry = useMemo(() => {
    return countries.find((c) => c.iso_code_2 === defaultIso2);
  }, [countries]);

  useEffect(() => {
    if (value) return;
    if (!defaultCountry) return;
    if (selectDefault)
      onChange(
        null,
        returnIso2 ? defaultCountry.iso_code_2 : defaultCountry.country_id
      );
  }, [countries, defaultCountry]);

  return (
    <Autocomplete
      name={name}
      size={size}
      value={selected}
      disabled={disabled || countries.length === 0}
      options={countries}
      getOptionLabel={(option) => option?.label || ''}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      fullWidth={fullWidth}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          fullWidth={fullWidth}
          size={size}
          placeholder={placeholder}
          error={error}
          helperText={helperText}
          label={label}
          onChange={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      )}
      onChange={(e, newValue) => {
        setChanged(true);
        if (onChange) onChange(e, newValue?.id);
      }}
    />
  );
};

export default CountrySelect;
